import { IShipmentsPerDay } from "../../../api/ShipmentsPerDay/ShipmentsPerDay.types";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import "./styles.scss";

interface Props {
  data?: IShipmentsPerDay[]
}

interface IdrayData {
  id: string,
  children: {
    id: string,
    value: number
  }[]
}

function DrayMovesByCarrierAndOriginLocation({ data }: Props) {
  function getData() {
    if (data) {
      const drayData: IdrayData[] = data
        .reduce((res: IdrayData[], item: IShipmentsPerDay) => {
          const { placeOfReceipt, trucker, containerCount } = item;
          const count = parseInt(containerCount);
          const existingReceipt = res.find((item) => item.id === placeOfReceipt);

          if (existingReceipt) {
            let existingTrucker: any = existingReceipt.children.find((item) => item.id === `${placeOfReceipt.slice(0, 3)}-${trucker}`);

            if (existingTrucker) {
              existingTrucker.value += count;
            } else {
              const newTrucker = {
                id: `${placeOfReceipt.slice(0, 3)}-${trucker}`,
                value: count
              };

              existingReceipt.children.push(newTrucker);
            }
          } else {
            const newItem: IdrayData = {
              id: placeOfReceipt,
              children: [
                {
                  id: `${placeOfReceipt.slice(0, 3)}-${trucker}`,
                  value: count
                }
              ]
            };

            res.push(newItem);
          }

          return res;
        }, []);

      const chartData: any = {
        id: "",
        children: drayData
      };

      return chartData;
    }
  }

  return (
    <div className="dray-moves-by-carrier-and-origin-location">
      <WidgetNivoBase.Sunburst
        title={
          <Tooltips
            label={
              <>
                <span><b>Trucker</b> comes from oeContainer</span>
                <span><b>PlaceOfReceipt</b> - coalesce between PlaceOfReceipt and PortofDischarge</span>
              </>
            }
            children="Dray Moves By Carrier & Origin Location"
          />
        }
        data={getData()}
        colors={{ scheme: "set3" }}
        enableArcLabels={true}
        arcLabel={(d: any) => `${d.id.split(",")[0].slice(0, 3)}`}
        valueFormat=">-"
      />
    </div>
  )
}

export default DrayMovesByCarrierAndOriginLocation;
